import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function StoriesPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: "Local Government Innovation Stories – Govlaunch", id: "wutLlE" })}
      description={intl.formatMessage({
        defaultMessage: "Read local government innovation stories from communities around the world. ",
        id: "LI0oCA",
      })}
    />
  );
}
